export default "__VITE_ASSET__DIHRQw9F__"